export type CheckoutCaptureMethod = "automatic" | "automatic_async" | "manual";

/** A pre-confirmation configuration change, not a bank decline. */
export class CheckoutContractChangedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CheckoutContractChangedError";
  }
}
